import React from 'react';
import JudgeScoringPageRotation from './JudgeScoringPageRotation';

export default function BarsScoring() {
  return <JudgeScoringPageRotation apparatus="bars" />;
}
